var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/components/bundle_column_error.tsx";
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Column, Stack, Text, IconButton } from 'soapbox/components/ui';
const messages = defineMessages({
  title: {
    "id": "bundle_column_error.title",
    "defaultMessage": "Network error"
  },
  body: {
    "id": "bundle_column_error.body",
    "defaultMessage": "Something went wrong while loading this page."
  },
  retry: {
    "id": "bundle_column_error.retry",
    "defaultMessage": "Try again"
  }
});
const BundleColumnError = ({
  onRetry
}) => {
  const intl = useIntl();
  const handleRetry = () => {
    onRetry();
  };
  return /*#__PURE__*/React.createElement(Column, {
    label: intl.formatMessage(messages.title),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    space: 4,
    alignItems: "center",
    justifyContent: "center",
    className: "bg-primary-50 dark:bg-slate-700 p-10 min-h-[160px] rounded-lg",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    iconClassName: "w-20 h-20",
    title: intl.formatMessage(messages.retry),
    src: require('@tabler/icons/refresh.svg'),
    onClick: handleRetry,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Text, {
    align: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 9
    }
  }, intl.formatMessage(messages.body))));
};
export default BundleColumnError;